import { LatLngLiteral, LatLngTuple } from "leaflet";
import { PropsWithChildren } from "react";
import { MapContainer, TileLayer, ZoomControl } from "react-leaflet";

import "leaflet/dist/leaflet.css";

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const CENTER: LatLngTuple = [52.1344, 5.1917];
const ZOOM = 8;

interface MapProps {
  center?: LatLngLiteral;
  height: string;
  width?: string;
  zoom?: number;
}

const Map = ({
  center,
  children,
  height,
  width,
  zoom,
}: PropsWithChildren<MapProps>) => {
  return (
    <MapContainer
      center={center ?? CENTER}
      style={{ height, width: width }}
      zoom={zoom ?? ZOOM}
      zoomControl={false}
    >
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {children}
      <ZoomControl position="topright" />
    </MapContainer>
  );
};

export default Map;
